import { getPDPDeliveryDateRange } from '@finn/ui-utils';
import { useMemo } from 'react';

import { GenericVehicleDetails } from '../../core/types';

export const useDeliveryText = (
  vehicle?: GenericVehicleDetails,
  term?: number,
  short?: boolean
) => {
  return useMemo(() => {
    const availabilityByTerm = vehicle?.availability_by_term[String(term)];
    const date = availabilityByTerm?.available_from ?? vehicle?.available_from;
    const deviationWeek =
      availabilityByTerm?.deviation_in_weeks ??
      vehicle?.available_from_deviation_in_weeks;

    const deliveryText = getPDPDeliveryDateRange({
      date: date ?? '',
      deviationWeek,
      short,
    });

    return deliveryText;
  }, [vehicle, term]);
};
